import { render, staticRenderFns } from "./CustomerBrief.vue?vue&type=template&id=9d2c601e&scoped=true&"
import script from "./CustomerBrief.vue?vue&type=script&lang=js&"
export * from "./CustomerBrief.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBrief.vue?vue&type=style&index=0&id=9d2c601e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2c601e",
  null
  
)

export default component.exports